<template>
  <div class='top_block'>
    <div class="content_dm">
      <img class='base_image title_dm' src='@/assets/image/pages/top/title.png'>
      <img class='base_image cloud_dm' src='@/assets/image/pages/top/clouds.png'>
      <UserRegistrationButtonBox/>
    </div>
  </div>
</template>

<script>
  import UserRegistrationButtonBox from "@/components/molecules/box/button/UserRegistrationButtonBox";

  export default {
    name: "TopBlock",
    components: {UserRegistrationButtonBox}
  }
</script>

<style lang='scss' scoped>
  @media screen and (min-width: 768px) {
    .top_block {
      display: flex;
      justify-content: center;
      margin-top: 0.5rem;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("~@/assets/image/pages/top/man_woman_sm.png");

      > .content_dm {
        display: flex;
        flex-flow: column;
        align-items: center;
        width: 1024px;
        margin-top: 5rem;

        > .base_image.title_dm {
          width: 50%;
        }

        > .base_image.cloud_dm {
          margin-top: 2rem;
          width: 55%;
        }

        > .user-registration-button_box {
          margin-top: 4rem;
        }
      }
    }
  }

  @media screen and (max-width: 767px) {
    .top_block {
      display: flex;
      justify-content: center;
      margin-top: 0.5rem;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("~@/assets/image/pages/top/man_woman_sm.png");

      > .content_dm {
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        width: 100%;

        > .base_image.title_dm {
          width: 70%;
          margin-top: 0.5rem;
        }

        > .base_image.cloud_dm {
          margin-top: 2rem;
        }

        > .user-registration-button_box {
          margin-top: 4rem;
        }
      }
    }
  }
</style>